import dayjs from "dayjs";
import "dayjs/locale/ru";
import {Timestamp} from "firebase/firestore";

export const formatDayjsDate = (
    date: string | number | Date | Timestamp | null | undefined
): string => {
    if (!date) return "";

    let convertedDate: string | number | Date | null | undefined;
    if (date instanceof Timestamp) {
        convertedDate = date.toDate();
    } else {
        convertedDate = date;
    }

    return dayjs(convertedDate).locale("ru").format("DD.MM.YYYY");
};
